module.exports = __webpack_public_path__ + "static/sequence_screenshot-ee026b50c26784e001a9cce8ac9919f4.png";